// extracted by mini-css-extract-plugin
module.exports = {"confidence":"confidence__n8D8j"};